// Display formatting for the AI-usage panel. Pure + deterministic so the panel
// stays declarative and the rules are unit-testable.

// Micro-USD (millionths of a dollar) → a human dollar string. Small figures
// (dev-volume cost) keep more precision so they don't collapse to "$0.00".
export const formatUsd = (micros: number): string => {
  const dollars = micros / 1_000_000;
  if (dollars === 0) return '$0.00';
  if (dollars < 0.01) return `$${dollars.toFixed(4)}`;
  return `$${dollars.toFixed(2)}`;
};

// Compact token counts: 4.8M, 12.3K, 940.
export const formatTokens = (tokens: number): string => {
  if (tokens >= 1_000_000) return `${(tokens / 1_000_000).toFixed(1)}M`;
  if (tokens >= 1_000) return `${(tokens / 1_000).toFixed(1)}K`;
  return String(tokens);
};

// Plain grouped integer (requests): 1,240. Pinned to en-US so tests and the UI
// agree regardless of the host locale.
export const formatCount = (count: number): string => count.toLocaleString('en-US');
